/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-file-application': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 11.25H3.75c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25H10c.69 0 1.25.56 1.25 1.25V10c0 .69-.56 1.25-1.25 1.25zm-6.25-7.5V10H10V3.75H3.75zm12.5 3.75V10h-2.5V7.5h2.5zm0-1.25h-2.5c-.69 0-1.25.56-1.25 1.25V10c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25V7.5c0-.69-.56-1.25-1.25-1.25zm0 7.5v2.5h-2.5v-2.5h2.5zm0-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25zM10 13.75v2.5H7.5v-2.5H10zm0-1.25H7.5c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25H10c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25z"/>'
  }
})
